import { useCallback, useMemo, useState } from "react";
import LogsTab, { LogsTabItem } from "./LogsTab/LogsTab";
import CommentsTab, { CommentsTabItem } from "./CommentsTab/CommentsTab";
import FixaTabs, {
  FixaTab,
  FixaTabPanel,
} from "@coworker/apprestructured/src/shared/wrappers/FixaTabs/FixaTabs";
import { useTranslation } from "@coworker/locales";
import styles from "./LogsAndComments.module.css";
import { AddComment } from "../AddComment/AddComment";

interface LogsAndCommentsProps {
  logsTabItems: LogsTabItem[];
  commentsTabItems: CommentsTabItem[];
  addCommentText: string;
  addCommentImages: File[];
  disableAllAddCommentInputs: boolean;
  disableAddCommentButton: boolean;
  onAddCommentTextChange: (text: string) => void;
  onAddCommentImagesChange: (images: File[]) => void;
  onAddCommentClick: () => void;
}

type Tab = "logs" | "comments";

export const LogsAndComments = ({
  logsTabItems,
  commentsTabItems,
  addCommentText,
  addCommentImages,
  disableAllAddCommentInputs,
  disableAddCommentButton,
  onAddCommentTextChange,
  onAddCommentImagesChange,
  onAddCommentClick,
}: LogsAndCommentsProps) => {
  const [currentTabId, setCurrentTabId] = useState<Tab>("logs");
  const { t } = useTranslation();

  const handleTabChanged = useCallback((newTabId: string) => {
    setCurrentTabId(newTabId as Tab);
  }, []);

  const overflowCarouselProps = useMemo(() => {
    return { className: styles["overflow"]! };
  }, []);

  return (
    <FixaTabs
      className={styles["root"]!}
      defaultActiveTab={currentTabId}
      overflowCarouselProps={overflowCarouselProps}
      tabs={[
        <FixaTab key="logs" tabPanelId="logs" text={t("historyString")} />,
        <FixaTab
          key="comments"
          tabPanelId="comments"
          text={t("commentsCountString", { count: commentsTabItems.length })}
        />,
      ]}
      onTabChanged={handleTabChanged}
      tabPanels={[
        <FixaTabPanel
          key="logs-tab-panel"
          tabPanelId="logs"
          className={styles["tabPanel"]!}
        >
          <LogsTab items={logsTabItems} />
        </FixaTabPanel>,
        <FixaTabPanel
          key="comments-tab-panel"
          tabPanelId="comments"
          className={styles["tabPanel"]!}
        >
          <CommentsTab items={commentsTabItems} />
          <AddComment
            text={addCommentText}
            images={addCommentImages}
            disableAllInputs={disableAllAddCommentInputs}
            disableAddButton={disableAddCommentButton}
            onTextChange={onAddCommentTextChange}
            onImagesChange={onAddCommentImagesChange}
            onAddClick={onAddCommentClick}
          />
        </FixaTabPanel>,
      ]}
    />
  );
};
